import { Controller } from "@hotwired/stimulus"

// This controller is used to manage date filters.
// It's expected to be used with the following markup:
// <div data-controller="filters--date-filter" data-filters--date-filter-name="sent_at" data-date-filter-selected-value="VALUE">
// ...
// </div>
// where:
// - VALUE is a value of the selected filter. It can be one of the following:
//   - "last1h"
//   - "last7d"
//   - "last30d"
//   - "current_year"
//   - "2020-03-10|"
//   - "|2020-03-10"
//   - "2020-03-10|2020-03-20"
export default class extends Controller {
  static get targets() {
    return ["button", "radioButton", "fromInput", "toInput", "customRangeText", "selectedCustom", "selectedIsPresent", "selectedIsEmpty"]
  }

  static get values() {
    return { name: String, selected: String, selectedFrom: String, selectedTo: String }
  }

  connect() {
    if (this.selectedValue.includes("|")) {
      this.selectedFromValue = this.selectedValue.split("|")[0]
      this.selectedToValue = this.selectedValue.split("|")[1]
      this.selectedValue = ""
    }
    this.render()
  }

  open(event) {
    if (event.detail.name === this.nameValue) {
      // The dropdown won't be shown without the timeout
      setTimeout(() => {
        this.buttonTarget.click()
      }, 10)
    }
  }

  apply() {
    let checkedRadioButton = this.radioButtonTargets.find(radioButton => radioButton.checked)
    let dropdown
    if (this.hasButtonTarget) {
      dropdown = bootstrap.Dropdown.getInstance(this.buttonTarget)
    }

    if (checkedRadioButton.value !== "custom") {
      this.selectedValue = checkedRadioButton.value
      this.selectedFromValue = ""
      this.selectedToValue = ""
      this.render()
      this.dispatchFilterEvent()
      return
    }

    // This is date range so we have to find inputs with values
    this.selectedFromValue = this.fromInputTarget.value
    this.selectedToValue = this.toInputTarget.value
    this.selectedValue = ""

    this.render()

    this.dispatchFilterEvent()

    if (dropdown) {
      dropdown.hide()
    }
  }

  clear() {
    this.selectedValue = ""
    this.selectedToValue = ""
    this.selectedFromValue = ""

    this.render()
    this.dispatchFilterEvent()
  }

  render() {
    this.radioButtonTargets.forEach(radioButton => {
      if (radioButton.value === "custom") {
        radioButton.checked = this.selectedFromValue || this.selectedToValue
      } else {
        radioButton.checked = radioButton.value === this.selectedValue
      }
    })

    if (!this.hasSelectedCustomTarget && !this.hasSelectedIsPresentTarget && !this.hasSelectedIsEmptyTarget) {
      // Only content exists so no need to render anything
      return
    }

    this.selectedCustomTarget.classList.add("d-none")
    this.selectedIsPresentTarget.classList.add("d-none")
    this.selectedIsEmptyTarget.classList.add("d-none")

    if (this.selectedValue === "*") {
      this.selectedCustomTarget.classList.add("d-none")
      this.selectedIsPresentTarget.classList.remove("d-none")
      this.selectedIsEmptyTarget.classList.add("d-none")
    } else if (this.selectedValue === "~") {
      this.selectedCustomTarget.classList.add("d-none")
      this.selectedIsPresentTarget.classList.add("d-none")
      this.selectedIsEmptyTarget.classList.remove("d-none")
    } else if (this.selectedValue || this.selectedFromValue || this.selectedToValue) {
      this.selectedCustomTarget.classList.remove("d-none")
      this.selectedIsPresentTarget.classList.add("d-none")
      this.selectedIsEmptyTarget.classList.add("d-none")

      if (this.selectedFromValue || this.selectedToValue) {
        this.customRangeTextTarget.innerText = `${this.selectedFromValue} - ${this.selectedToValue}`
      } else if (this.selectedValue && this.selectedValue !== "") {
        this.customRangeTextTarget.innerText = i18n.t(`js.front.timeframe.${this.selectedValue}`)
      }
    }
  }

  dispatchFilterEvent() {
    if (this.selectedValue) {
      this.dispatch("filter", { detail: { name: this.nameValue, values: this.selectedValue } })
      return
    }
    if (this.selectedFromValue === "" && this.selectedToValue === "") {
      this.dispatch("filter", { detail: { name: this.nameValue, values: "" } })
      return
    }

    // This is date range
    this.dispatch("filter", {
      detail: {
        name: this.nameValue,
        values: `${this.selectedFromValue}|${this.selectedToValue}`
      }
    })
  }
}
